import React from 'react';
import PropTypes, { any } from 'prop-types';

import UtrLogo from '../../UtrLogo';

import styles from './matchSheetHeader.scss';

const MatchSheetHeader = (props) => {
    const { match } = props;
    const { medalDisplay } = match;

    return (
        <div className={styles.matchSheetHeader}>
            <UtrLogo className={styles.logo} />
            {medalDisplay && (
                <div className={styles.matchMedal}>
                    {medalDisplay}
                </div>
            )}
        </div>
    );
};

MatchSheetHeader.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
};

MatchSheetHeader.defaultProps = {};

export default MatchSheetHeader;
